import React, { Component } from "react";
import LoadingView from "presentational/common/LoadingView";
import IconButtonView from "presentational/common/IconButtonView";
import PropTypes from "prop-types";

class CommonMoreRequestButton extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    disableLeftMargin: PropTypes.bool,
    disableRightMargin: PropTypes.bool
  };

  static defaultProps = {
    disableLeftMargin: false,
    disableRightMargin: false
  };

  getCss() {
    const { isLoading } = this.props;
    const { maxHeightOfElem } = this.state;
    return {
      root: {
        display: "flex",
        alignItems: "center",
        minHeight: maxHeightOfElem || 0
      },
      loadingWrapper: {
        display: maxHeightOfElem && !isLoading ? "none" : undefined
      },
      iconWrapper: {
        display: maxHeightOfElem && isLoading ? "none" : undefined
      }
    };
  }

  state = {
    maxHeightOfElem: undefined
  };

  setMaxHeightOfElem() {
    const heightOfLoading = this.loadingElem.clientHeight;
    const heightOfIcon = this.iconElem.clientHeight;

    if (
      typeof heightOfLoading === "undefined" ||
      typeof heightOfIcon === "undefined"
    ) {
      console.log("error");
      console.error("error");
      return null;
    }

    const maxHeightOfElem = Math.max(heightOfLoading, heightOfIcon);
    this.setState({ maxHeightOfElem });
  }

  render() {
    const { onClick, disableLeftMargin, disableRightMargin } = this.props;
    const css = this.getCss();

    return (
      <div style={css.root}>
        <span
          ref={ref => {
            this.loadingElem = ref;
          }}
          style={css.loadingWrapper}
        >
          <LoadingView />
        </span>
        <span
          ref={ref => {
            this.iconElem = ref;
          }}
          style={css.iconWrapper}
        >
          <IconButtonView
            type={"moreRequest"}
            disableLeftMargin={disableLeftMargin}
            disableRightMargin={disableRightMargin}
            onClick={onClick}
          />
        </span>
      </div>
    );
  }

  componentDidMount() {
    this.setMaxHeightOfElem();
  }
}

export default CommonMoreRequestButton;
